import { PlaceholderPage } from './PlaceholderPage';

/**
 * /admin/agents — COG → Agents. Management surface for AI agent rulesets
 * (ADR-075, CEDAR-016/019). Placeholder shell (ADR-036 PlaceholderPage).
 * Agents are a DISTINCT Cedar principal type with their own ruleset
 * vocabulary, bounded by the universal forbid floor (no agent views staff
 * identity data, gets the super_admin tier, or edits rulesets/the floor).
 * Ruleset DEFINITION is super_admin-gated — "the floor protects the floor"
 * (CEDAR-019). Real implementation lands when the ruleset editor is built.
 */
export function AgentsPage() {
  return (
    <PlaceholderPage
      title="Agents"
      plannedPhase="Phase 6+"
      intent={
        <>
          The AI-agent administration surface introduced with the staff Cedar
          AAA migration (ADR-075). Agents are first-class Cedar principals with
          their own <em>ruleset</em> vocabulary — never human roles — bounded by
          a universal forbid floor (no agent may view staff identity data, reach
          the super_admin tier, or edit rulesets / the floor). This page is where
          rulesets are defined and bound to agents; ruleset definition is{' '}
          <code>super_admin</code>-gated, so the floor protects the floor. The
          editor is built in a follow-up.
        </>
      }
      features={[
        'Define / edit agent rulesets (super_admin only — the floor protects the floor)',
        'Bind rulesets to agent principals (e.g. comms-agent → email:initiate)',
        'View the universal agent forbid floor and per-ruleset grants',
        'Per-agent action audit trail ("audit by default")',
        'No-impersonation guarantee surfaced per agent',
      ]}
    />
  );
}
